import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import * as React from 'react';
import { Box } from 'rebass/styled-components';

import Button from '@/components/Button/Button';
import Section from '@/components/Section';
import Text from '@/components/Text';
import Dropzone from '@/widgets/Dropzone';
import DocumentAssignDialog from '@/widgets/Request/DocumentAssignDialog';

import ProjectDocList from './ProjectDocList';

const DocumentUpload = ({ taskId, sid }) => {
  const { query } = useRouter();
  const [projectId, setProjectId] = React.useState('');

  const onCloseDialog = () => {
    setProjectId('');
  };

  const onOpenAssignDialog = () => {
    setProjectId(query?.id);
  };

  return (
    <>
      <DocumentAssignDialog projectId={projectId} taskId={taskId} sid={sid} onCloseClick={onCloseDialog} />
      <Box pl={['2.15rem']} pr={['15px', '0', '0']}>
        <Section padded>
          <ProjectDocList tid={taskId} sid={sid} />
          <Text variant="taskTextLight">Dokumente</Text>
          <Dropzone isWidget projectId={query?.id} taskId={taskId} sid={sid} />
          <Button my="4" variant="primary" width="100%" onClick={onOpenAssignDialog}>
            Bestehendes Dokument zuweisen
          </Button>
        </Section>
      </Box>
    </>
  );
};

DocumentUpload.propTypes = {
  sid: PropTypes.string.isRequired,
  taskId: PropTypes.string.isRequired,
};

export default DocumentUpload;
